import {
    accommodationRateOptionAppliesToZodEnum,
    accommodationRateOptionAppliesZodEnum,
} from "@@/shared/acquire/accommodation-rate-option-applies";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { priceZodSchema } from "@@/shared/prices/price";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { z } from "zod";
import {
    accommodationRateOptionIdFactory,
    accommodationRateOptionIdZodSchema,
} from "./accommodation-rate-option-id";

// Accommodation Rate Option
const accommodationRateOptionZodObject = z.object({
    _id: accommodationRateOptionIdZodSchema,
    _type: z.literal("ACCOMMODATION_RATE_OPTION"),
    _createdAt: isoAndUnixZodSchema,
    title: requiredTranslatableZodSchema,
    description: translatableZodSchema,
    price: priceZodSchema,
    /**
     * The rate can't be lower than min price, no matter
     * how many discounts or price adjustments are applied
     */
    appliesTo: accommodationRateOptionAppliesToZodEnum,
    applies: accommodationRateOptionAppliesZodEnum,
});
type AccommodationRateOption = z.infer<typeof accommodationRateOptionZodObject>;

// Factory
const accommodationRateOptionFactoryParamsZodObject =
    accommodationRateOptionZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof accommodationRateOptionFactoryParamsZodObject
>;

const accommodationRateOptionFactory = (params: FactoryParams) => {
    const command: AccommodationRateOption = {
        ...params,
        _id: accommodationRateOptionIdFactory(),
        _type: "ACCOMMODATION_RATE_OPTION",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export {
    accommodationRateOptionFactory,
    accommodationRateOptionFactoryParamsZodObject,
    accommodationRateOptionZodObject,
};
export type {
    AccommodationRateOption,
    FactoryParams as AccommodationRateOptionFactoryParams,
};
